//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpResponseBase } from '@angular/common/http';

export const SUPPORT_KNOWLEDGE_PUBLIC_API_BASE_URL = new InjectionToken<string>('SUPPORT_KNOWLEDGE_PUBLIC_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class SupportCardsClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(SUPPORT_KNOWLEDGE_PUBLIC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getList(scope: SupportCardScope | null, domain: string | null, language: string | null, status: SupportCardStatus | null, enabled: boolean | null, search: string | null, page: number | null, pageSize: number | null): Observable<SupportCardListPageDto> {
        let url_ = this.baseUrl + "/public/SupportCards?";
        if (scope === undefined)
            throw new globalThis.Error("The parameter 'scope' must be defined.");
        else if(scope !== null)
            url_ += "Scope=" + encodeURIComponent("" + scope) + "&";
        if (domain === undefined)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        else if(domain !== null)
            url_ += "Domain=" + encodeURIComponent("" + domain) + "&";
        if (language === undefined)
            throw new globalThis.Error("The parameter 'language' must be defined.");
        else if(language !== null)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        if (status === undefined)
            throw new globalThis.Error("The parameter 'status' must be defined.");
        else if(status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (enabled === undefined)
            throw new globalThis.Error("The parameter 'enabled' must be defined.");
        else if(enabled !== null)
            url_ += "Enabled=" + encodeURIComponent("" + enabled) + "&";
        if (search === undefined)
            throw new globalThis.Error("The parameter 'search' must be defined.");
        else if(search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (page === undefined)
            throw new globalThis.Error("The parameter 'page' must be defined.");
        else if(page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined)
            throw new globalThis.Error("The parameter 'pageSize' must be defined.");
        else if(pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportCardListPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportCardListPageDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<SupportCardListPageDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportCardListPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'SupportCardsClient.GetList');
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<SupportCardDto> {
        let url_ = this.baseUrl + "/public/SupportCards/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportCardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportCardDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SupportCardDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportCardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'SupportCardsClient.GetById');
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, request: UpdateSupportCardRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/public/SupportCards/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'SupportCardsClient.Update');
            }));
        }
        return _observableOf(null as any);
    }

    getHistory(id: string): Observable<SupportCardChangeEntryDto[]> {
        let url_ = this.baseUrl + "/public/SupportCards/{id}/history";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportCardChangeEntryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportCardChangeEntryDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<SupportCardChangeEntryDto[]> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportCardChangeEntryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'SupportCardsClient.GetHistory');
            }));
        }
        return _observableOf(null as any);
    }

    approve(id: string): Observable<void> {
        let url_ = this.baseUrl + "/public/SupportCards/{id}/approve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'SupportCardsClient.Approve');
            }));
        }
        return _observableOf(null as any);
    }

    enable(id: string): Observable<void> {
        let url_ = this.baseUrl + "/public/SupportCards/{id}/enable";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'SupportCardsClient.Enable');
            }));
        }
        return _observableOf(null as any);
    }

    disable(id: string): Observable<void> {
        let url_ = this.baseUrl + "/public/SupportCards/{id}/disable";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'SupportCardsClient.Disable');
            }));
        }
        return _observableOf(null as any);
    }

    splitToDomains(id: string): Observable<SplitToDomainsResultDto> {
        let url_ = this.baseUrl + "/public/SupportCards/{id}/split-to-domains";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSplitToDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSplitToDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplitToDomainsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplitToDomainsResultDto>;
        }));
    }

    protected processSplitToDomains(response: HttpResponseBase): Observable<SplitToDomainsResultDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SplitToDomainsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'SupportCardsClient.SplitToDomains');
            }));
        }
        return _observableOf(null as any);
    }
}

export class SupportCardListPageDto implements ISupportCardListPageDto {
    items!: SupportCardListItemDto[] | undefined;
    pageNumber!: number;
    pageSize!: number;
    pageCount!: number;
    totalItemCount!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: ISupportCardListPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SupportCardListItemDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.pageCount = _data["pageCount"];
            this.totalItemCount = _data["totalItemCount"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): SupportCardListPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportCardListPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["pageCount"] = this.pageCount;
        data["totalItemCount"] = this.totalItemCount;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface ISupportCardListPageDto {
    items: SupportCardListItemDto[] | undefined;
    pageNumber: number;
    pageSize: number;
    pageCount: number;
    totalItemCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class SupportCardListItemDto implements ISupportCardListItemDto {
    id!: string;
    scope!: SupportCardScope;
    domain!: string | undefined;
    language!: string | undefined;
    intent!: string | undefined;
    problemPreview!: string | undefined;
    sourceThreadCount!: number;
    status!: SupportCardStatus;
    enabled!: boolean;
    updatedAt!: Date;

    constructor(data?: ISupportCardListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scope = _data["scope"];
            this.domain = _data["domain"];
            this.language = _data["language"];
            this.intent = _data["intent"];
            this.problemPreview = _data["problemPreview"];
            this.sourceThreadCount = _data["sourceThreadCount"];
            this.status = _data["status"];
            this.enabled = _data["enabled"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SupportCardListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportCardListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scope"] = this.scope;
        data["domain"] = this.domain;
        data["language"] = this.language;
        data["intent"] = this.intent;
        data["problemPreview"] = this.problemPreview;
        data["sourceThreadCount"] = this.sourceThreadCount;
        data["status"] = this.status;
        data["enabled"] = this.enabled;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ISupportCardListItemDto {
    id: string;
    scope: SupportCardScope;
    domain: string | undefined;
    language: string | undefined;
    intent: string | undefined;
    problemPreview: string | undefined;
    sourceThreadCount: number;
    status: SupportCardStatus;
    enabled: boolean;
    updatedAt: Date;
}

export enum SupportCardScope {
    Undefined = 0,
    Global = 1,
    Country = 2,
}

export enum SupportCardStatus {
    Undefined = 0,
    Draft = 1,
    Approved = 2,
}

export class SupportCardDto implements ISupportCardDto {
    id!: string;
    scope!: SupportCardScope;
    domain!: string | undefined;
    splitAt!: Date | undefined;
    originCardId!: string | undefined;
    language!: string | undefined;
    intent!: string | undefined;
    problem!: string | undefined;
    canonicalSolution!: string | undefined;
    relatedTool!: string | undefined;
    examplePhrasings!: string[] | undefined;
    sourceThreadCount!: number;
    status!: SupportCardStatus;
    enabled!: boolean;
    createdAt!: Date;
    createdBy!: string | undefined;
    updatedAt!: Date;
    updatedBy!: string | undefined;

    constructor(data?: ISupportCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scope = _data["scope"];
            this.domain = _data["domain"];
            this.splitAt = _data["splitAt"] ? new Date(_data["splitAt"].toString()) : undefined as any;
            this.originCardId = _data["originCardId"];
            this.language = _data["language"];
            this.intent = _data["intent"];
            this.problem = _data["problem"];
            this.canonicalSolution = _data["canonicalSolution"];
            this.relatedTool = _data["relatedTool"];
            if (Array.isArray(_data["examplePhrasings"])) {
                this.examplePhrasings = [] as any;
                for (let item of _data["examplePhrasings"])
                    this.examplePhrasings!.push(item);
            }
            this.sourceThreadCount = _data["sourceThreadCount"];
            this.status = _data["status"];
            this.enabled = _data["enabled"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): SupportCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scope"] = this.scope;
        data["domain"] = this.domain;
        data["splitAt"] = this.splitAt ? this.splitAt.toISOString() : undefined as any;
        data["originCardId"] = this.originCardId;
        data["language"] = this.language;
        data["intent"] = this.intent;
        data["problem"] = this.problem;
        data["canonicalSolution"] = this.canonicalSolution;
        data["relatedTool"] = this.relatedTool;
        if (Array.isArray(this.examplePhrasings)) {
            data["examplePhrasings"] = [];
            for (let item of this.examplePhrasings)
                data["examplePhrasings"].push(item);
        }
        data["sourceThreadCount"] = this.sourceThreadCount;
        data["status"] = this.status;
        data["enabled"] = this.enabled;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ISupportCardDto {
    id: string;
    scope: SupportCardScope;
    domain: string | undefined;
    splitAt: Date | undefined;
    originCardId: string | undefined;
    language: string | undefined;
    intent: string | undefined;
    problem: string | undefined;
    canonicalSolution: string | undefined;
    relatedTool: string | undefined;
    examplePhrasings: string[] | undefined;
    sourceThreadCount: number;
    status: SupportCardStatus;
    enabled: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    updatedAt: Date;
    updatedBy: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class SupportCardChangeEntryDto implements ISupportCardChangeEntryDto {
    id!: string;
    cardId!: string;
    action!: SupportCardChangeAction;
    changedBy!: string | undefined;
    changedByName!: string | undefined;
    changedAt!: Date;
    changesJson!: string | undefined;

    constructor(data?: ISupportCardChangeEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardId = _data["cardId"];
            this.action = _data["action"];
            this.changedBy = _data["changedBy"];
            this.changedByName = _data["changedByName"];
            this.changedAt = _data["changedAt"] ? new Date(_data["changedAt"].toString()) : undefined as any;
            this.changesJson = _data["changesJson"];
        }
    }

    static fromJS(data: any): SupportCardChangeEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportCardChangeEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardId"] = this.cardId;
        data["action"] = this.action;
        data["changedBy"] = this.changedBy;
        data["changedByName"] = this.changedByName;
        data["changedAt"] = this.changedAt ? this.changedAt.toISOString() : undefined as any;
        data["changesJson"] = this.changesJson;
        return data;
    }
}

export interface ISupportCardChangeEntryDto {
    id: string;
    cardId: string;
    action: SupportCardChangeAction;
    changedBy: string | undefined;
    changedByName: string | undefined;
    changedAt: Date;
    changesJson: string | undefined;
}

export enum SupportCardChangeAction {
    Undefined = 0,
    Updated = 1,
    Approved = 2,
    Enabled = 3,
    Disabled = 4,
    SplitIntoDomains = 5,
    CreatedBySplit = 6,
}

export class SplitToDomainsResultDto implements ISplitToDomainsResultDto {
    copies!: SplitToDomainsCopyDto[] | undefined;

    constructor(data?: ISplitToDomainsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["copies"])) {
                this.copies = [] as any;
                for (let item of _data["copies"])
                    this.copies!.push(SplitToDomainsCopyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SplitToDomainsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplitToDomainsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.copies)) {
            data["copies"] = [];
            for (let item of this.copies)
                data["copies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISplitToDomainsResultDto {
    copies: SplitToDomainsCopyDto[] | undefined;
}

export class SplitToDomainsCopyDto implements ISplitToDomainsCopyDto {
    id!: string;
    domain!: string | undefined;

    constructor(data?: ISplitToDomainsCopyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): SplitToDomainsCopyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplitToDomainsCopyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["domain"] = this.domain;
        return data;
    }
}

export interface ISplitToDomainsCopyDto {
    id: string;
    domain: string | undefined;
}

export class UpdateSupportCardRequestDto implements IUpdateSupportCardRequestDto {
    intent!: string | undefined;
    problem!: string | undefined;
    canonicalSolution!: string | undefined;
    relatedTool!: string | undefined;
    examplePhrasings!: string[] | undefined;

    constructor(data?: IUpdateSupportCardRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intent = _data["intent"];
            this.problem = _data["problem"];
            this.canonicalSolution = _data["canonicalSolution"];
            this.relatedTool = _data["relatedTool"];
            if (Array.isArray(_data["examplePhrasings"])) {
                this.examplePhrasings = [] as any;
                for (let item of _data["examplePhrasings"])
                    this.examplePhrasings!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSupportCardRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupportCardRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intent"] = this.intent;
        data["problem"] = this.problem;
        data["canonicalSolution"] = this.canonicalSolution;
        data["relatedTool"] = this.relatedTool;
        if (Array.isArray(this.examplePhrasings)) {
            data["examplePhrasings"] = [];
            for (let item of this.examplePhrasings)
                data["examplePhrasings"].push(item);
        }
        return data;
    }
}

export interface IUpdateSupportCardRequestDto {
    intent: string | undefined;
    problem: string | undefined;
    canonicalSolution: string | undefined;
    relatedTool: string | undefined;
    examplePhrasings: string[] | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    operationName: string;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any, operationName?: string) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
        this.operationName = operationName ?? '';
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any, operationName?: string): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null, operationName));
}

function anyToText(data: unknown): Observable<string>{
    if (data instanceof Blob) return blobToText(data);
    return new Observable<string>(observer => {
        if (!data) {
            observer.next("");
            observer.complete();
            return;
        }
        observer.next(JSON.stringify(data));
        observer.complete();
    });
}

function blobToText(blob: Blob): Observable<string> {
    return new Observable<string>(observer => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            try {
                blob.text().then((blobText: string) => {
                    observer.next(blobText);
                    observer.complete();
                }, err => observer.error(err));
            }
            catch { observer.error(); }
        }
    });
}